import styled from 'styled-components';

export const BannerContainer = styled.div`
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 70px;
  padding: 20px;

  @media (max-width: 768px) {
    border-radius: 0;
    padding: 10px;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px;
  color: #333;

  @media (max-width: 768px) {
    padding: 10px;
    text-align: center;
  }
`;

export const Title = styled.h1`
  font-size: 2em;
  color: #0044cc;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 1.5em;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2em;
  color: #0044cc;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 1em;
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.9em;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  border-radius: 15px;
  display: none;

  @media (max-width: 768px) {
    margin-top: 20px;
    border-radius: 15px;
    height: auto;
    background-size: cover;
    display: block;
  }
`;

export const AddImage = styled.img`
  flex: 1;
  max-width: 40%;
  height: auto;
  border-radius: 15px;

  @media (max-width: 768px) {
    margin-top: 20px;
    display: none;
    border-radius: 0;
  }
`;

export const AdditionalContent = styled.div`
  padding: 20px;
  color: #333;

  @media (max-width: 768px) {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Paragraph = styled.p`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;

export const DiagnosisContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const Diagnosis = styled.div`
  background-color: #006acb;
  color: #fff;
  border-radius: 21px;
  border: 1px solid #006acb;
  padding: 5px 10px;

  font-size: 0.9em;
  width: fit-content;
  @media (max-width: 768px) {
    padding: 10px 8px;
    font-size: 0.8em;
    width: fit-content;
  }
`;

export const ParagraphFeatured = styled.div`
  text-align: center;
  font-size: 19px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 18px;
    text-align: left;
  }
`;

export const Logo = styled.img`
  max-width: 180px;
  display: none;

  @media (max-width: 768px) {
    margin: auto;
    max-width: 180px;
    display: block;
    margin-top: 2em;
    width: 100%;
  }
`;
